import { Pipe, PipeTransform } from "@angular/core";
import type { Duration } from "../../../core-ui/utils/dayjs";

@Pipe({
  name: "duration",
  standalone: false,
})
export class DurationPipe implements PipeTransform {
  transform(value: Duration): string {
    try {
      return !!value
        ? (value.hours() > 0 ? `${value.hours()}h ` : "") +
            `${value.minutes()}m ${value.seconds()}s`
        : "-";
    } catch (ex) {
      return "-";
    }
  }
}
